/*
 * Register Success Ctrl
 */

module.controller('successRegisterCtrl', ['$rootScope', '$scope', '$stateParams', 'authService', 'LimitsService', '$q', function ($rootScope, $scope, $stateParams, authService, LimitsService, $q) {
  $scope.successMessage = $stateParams.successMessage;

  $scope.goToDashboard = function(){
    //log in the member and go to the verification screen
    authService.login($stateParams.credentials, function(error, response){
      if(!response){
        handleError(error);
      } else {
        $q.all([
          authService.checkStatus(),
          authService.getFeatureAccess(),
          LimitsService.update()
        ]).then(function(results){
          // set status and feature access
          authService.setStatusSession(results[0].data);
          authService.setFeatureAccessSession(results[1].data);

          // If signup is complete, direct CH to dashboard
          authService.injectUserToDashboard();

        }).catch(function(err){
          handleError(err);
        });
      }
    });
  };

  var handleError = function (error){
    $scope.loading = false;

    // 403 errors
    if(error.status === 403 && error.data.ErrorCode){
      switch(error.data.ErrorCode){
        case 150:
          //if the user needs to go through the Jumio KYC process in the dashboard
          $q.all([
            authService.checkStatus(),
            authService.getFeatureAccess(),
            LimitsService.update()
          ]).then(function(results){
            // set status and feature access
            authService.setStatusSession(results[0].data);
            authService.setFeatureAccessSession(results[1].data);

            // If signup is complete, direct CH to dashboard
            authService.injectUserToDashboard();

          }).catch(function(err){
            $scope.alertError.show = true;
            $scope.alertError.message = "Oops! Something went wrong on our end. Please try again.";      });
          break;
        default:
          $scope.alertError.show = true;
          $scope.alertError.message = "Oops! Something went wrong on our end. Please try again.";
          break;
      }
    }
    // 502 errors
    if(error.status === 502){
      $scope.alertError.show = true;
      $scope.alertError.message = 'Oops ' + $scope.brand.programName + ' is experiencing connectivity issues, please try again in a bit.';
    }
    // 401 and 400 errors
    if(error.status === 401 || error.status === 400){
      $scope.alertError.show = true;
      $scope.alertError.message = 'Invalid username or password provided.';
    }
  };
}]);
